import { AsyncAction } from "src/state/_types";
import logger from 'src/utils/logger';

export const initializeSubscriptions: AsyncAction = async ({state,effects}) => {
    if ( state.auth.user_id && state.auth.session_id) {
        effects.subscriptions.initialize({auth:state.auth});
        state.online = true
    } else {
        logger('No Session For Subscription API')
    }    
}